export const setNavOpened = (boolean) => {
    return {
        type: 'SET_NAV_OPENED',
        payload: boolean
    }
}